import Image from "next/legacy/image";
import { blurDataURL } from "../../../utils/constants/images";
import { getPlayerPosition } from "../../../utils/helpers/helpers";
import Badge from "../../common/Badge";

const PlayerAvatar = ({
  playerAvatar,
  playerFullName,
  playerPosition,
  playerStatus,
}) => {
  const playerPositionFormatted = getPlayerPosition(playerPosition);

  return (
    <div className="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0 lg:max-w-none lg:py-20">
      {/* Testimonial card*/}
      <div className="relative pt-64 pb-10 rounded-md shadow-xl overflow-hidden bg-black">
        <div className="absolute inset-0 h-full w-full object-contain">
          <Image
            src={playerAvatar}
            alt="Player Avatar"
            objectFit="contain"
            layout="fill"
            quality={100}
            placeholder="blur"
            blurDataURL={blurDataURL}
          />
        </div>

        {/* <div className="absolute inset-0 bg-red-500 dark:bg-green-600  mix-blend-multiply" /> */}
        <div className="absolute inset-0 bg-gradient-to-t from-black opacity-90" />
        {playerStatus && <Badge categoryName={playerStatus} />}
        <div className="relative px-8">
          <blockquote className="mt-8">
            <footer className="mt-4">
              <p className="text-base font-semibold text-red-200 dark:text-green-200">
                {`${playerFullName}`}
              </p>
            </footer>
          </blockquote>
        </div>
      </div>
    </div>
  );
};

export default PlayerAvatar;
